import React from "react";
import { ButtonGroup, Button } from "reactstrap";
import { Spinner } from "react-activity";
import "react-activity/dist/react-activity.css";
export const renderVenueSelectionHeader = (allSelected, onToggle) => (
  <label className="venues-selection" title={allSelected ? "Clear visible selection" : "Select all visible venues"}>
    <input type="checkbox" checked={allSelected} onChange={onToggle} aria-label="Select all visible venues" />
    <span />
  </label>
);

export const renderVenueSelectionCell = (isSelected, onToggle, isDisabled) => (
  <label className="venues-selection" title={isSelected ? "Deselect venue" : "Select venue"}>
    <input
      type="checkbox"
      checked={isSelected}
      onChange={onToggle}
      disabled={isDisabled}
      aria-label={isSelected ? "Deselect venue" : "Select venue"}
    />
    <span />
  </label>
);

export const renderVenuesActions = (deleteAction, cellInfo) => {
  const deleteTarget = cellInfo.original && cellInfo.original.id ? cellInfo.original : cellInfo.index;
  return (
    <ButtonGroup className="venues-action-group">
      <Button
        color="danger"
        title="Delete venue"
        onClick={() => {
          deleteAction(deleteTarget);
        }}
      >
        <i className="fa  fa-trash" />
        {cellInfo.original.isDeleting ? (
          <>
            &nbsp;
            <Spinner size={10} animating={true} color={"white"} />
          </>
        ) : null}
      </Button>
    </ButtonGroup>
  );
};
